import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from './translation/en.json'
import translationPT from './translation/pt.json'

const fallbackLng = ['en']
const availableLanguages = ['en', 'pt']

const resources = {
  en: {
    translation: translationEN
  },
  pt: {
    translation: translationPT
  }
}
i18n.use(initReactI18next).init({
  resources,
  lng: 'pt',
  fallbackLng: fallbackLng,
  interpolation: {
    escapeValue: false
  }
})
export default i18n
